/**
 * descriptionSnippets selectors
 */
import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

interface State {
    descriptionSnippets: {
        [string]: {
            name: string
        }
    };
}

interface Props {
    descriptionSnippetId?: number | string;
}

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectDescriptionSnippets = (state: State) => state.descriptionSnippets;
const selectDescriptionSnippetId = (state: State, props: Props) =>
    props.descriptionSnippetId && `${props.descriptionSnippetId}`;

const selectDescriptionSnippet = createDeepEqualSelector(
    selectDescriptionSnippets,
    selectDescriptionSnippetId,
    (descriptionSnippetsState, descriptionSnippetId) =>
        descriptionSnippetId && descriptionSnippetsState[descriptionSnippetId]
);

const makeSelectDescriptionSnippetValue = (field: string) =>
    createDeepEqualSelector(
        selectDescriptionSnippet,
        descriptionSnippetState =>
            descriptionSnippetState && descriptionSnippetState[field]
    );

export {
    selectDescriptionSnippets,
    selectDescriptionSnippet,
    makeSelectDescriptionSnippetValue
};
